import { render, staticRenderFns } from "./matchDetailsOld.vue?vue&type=template&id=3bd995f1&scoped=true&lang=pug&"
import script from "./matchDetailsOld.vue?vue&type=script&lang=js&"
export * from "./matchDetailsOld.vue?vue&type=script&lang=js&"
import style0 from "./matchDetailsOld.vue?vue&type=style&index=0&id=3bd995f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd995f1",
  null
  
)

export default component.exports